<template>
  <div>
    <el-dialog title="" v-model="modalShow" size="tiny" custom-class="cant-book-modal" @close="modalClose">
      <div class="share-body">
        <div class="sorry-left">
          <div class="sorry-txt">请用微信扫描右侧二维码</div>
          <div class="sorry-txt important">使用『办签助手』小程序办理</div>
          <div class="sorry-txt">此款签证上上签官网暂不支持</div>
          <img class="sorry-img" src="../../assets/imgs/sorry.png">
        </div>

        <div class="share-code">
          <div class="share-code-img" :style="'background-image:url(' + codeUrl + ')'" v-loading="modalShow && !codeUrl"></div>
        </div>
        <div class="code-txt" v-if="env" style="top:auto;bottom:30px;color:red;width:auto;left:80px">(测试、开发环境中二维码无效，仅为展示)</div>
        <div class="code-txt">{{product.product_name}}</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import wxUtils from '../../libs/wx-utils';
import User from '../../libs/user';
import { env } from '../../libs/env';

export default {
  name: 'cant-book-model',
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false,
    },
    product: {
      type: Object,
      required: true,
      default() {
        return {};
      },
    },
    codeImg: {
      type: String,
      required: true,
      default: '',
    },
  },
  data() {
    return {
      env,
      codeUrl: '',
      cache: {},
      modalShow: false,
    };
  },
  watch: {
    cantBookShow(nv) {
      if (nv) {
        if (this.codeImg || this.cache[this.product.visa_product_id]) {
          this.codeUrl =
            this.codeImg || this.cache[this.product.visa_product_id];
        } else {
          wxUtils
            .getVisaDetailWxaCode(this.product.visa_product_id, User.peer_account_id)
            .then((base64) => {
              this.codeUrl = base64;
              this.cache[this.product.visa_product_id] = base64;
            })
            .catch((e) => {
              if (e) console.log(e);
            });
        }
      }
    },
    value(newVal) {
      this.modalShow = newVal;
    },
  },
  methods: {
    modalClose() {
      this.$emit('input', false);

      setTimeout(() => {
        this.codeUrl = '';
      }, 200);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/product/cant-book-modal.vue